import * as  React from 'react';

const Header = (): JSX.Element => {
    return (
        <div className="container-fluid">
            <a href="/home"><img src={'/imgs/ACscript-logo.png'} alt="ACscripts Logo" /></a>
        </div>
    );
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx